/**
 * Segment event names: bulk content converter (BulkConvertDrawer).
 */

export const BULK_CONVERTER_SEGMENT = {
  CREATE_DOCUMENT_CLICK: 'BulkConverter:CreateDocumentClick',
  /** User closed the drawer (drawer X, Pear UI close, or error Cancel). Overlay/Escape disabled. */
  PDL_DRAWER_CLOSE: 'BulkConverter:PDLDrawerClose',
  CONVERT_UPLOAD_COMPLETE: 'BulkConverter:ConvertUploadComplete',
  /** My Content (test list) grade/subject filter — mirrors Pear usage-events naming. */
  MY_CONTENT_FILTER_SELECTED: 'BulkConverter:MyTests:FilterSelected',
  MY_CONTENT_BULK_CONVERSION_CSV_DOWNLOAD:
    'BulkConverter:MyTests:ClickBulkConversionCsvDownload',
}
